import type { ServerError, ServerParseError } from '@apollo/client';

import { isWeb } from '@savvy/deprecated-shared/utils/platform/is-web';
import {
  SALESFORCE_ACCESS_TOKEN_EXPIRATION,
  SALESFORCE_ACCESS_TOKEN_KEY,
} from '@savvy/deprecated-shared/utils/salesforce';

export function removeSalesforceAccessToken() {
  if (!isWeb() || typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(SALESFORCE_ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(SALESFORCE_ACCESS_TOKEN_EXPIRATION);
}

export function setSalesforceAccessToken(accessToken: string) {
  if (!isWeb() || typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(SALESFORCE_ACCESS_TOKEN_KEY, accessToken);
  setSalesforceTokenExpiration();
}

function setSalesforceTokenExpiration() {
  if (typeof window === 'undefined') {
    return;
  }
  // Salesforce Access Tokens typically expire in 2 hours (7,200 seconds), but this value is not guaranteed to be static—Salesforce could change it at any time with no warning.
  const expirationTime = new Date().getTime() + 30 * 60 * 1000; // 30min in milliseconds

  window.localStorage.setItem(SALESFORCE_ACCESS_TOKEN_EXPIRATION, expirationTime.toString());
}

export function isServerError(error: Error | ServerParseError | ServerError): error is ServerError {
  return 'statusCode' in error;
}
